import React, { createContext, useReducer } from "react";
import Reducer from "./Reduser";

const initialState = {
    ui_pw_input_visibility: false,
    ui_fav_box: false,
    ui_chat_box: {
        show: false,
        children: "",
    },
    ui_large_modal: {
        show: false,
        title: "",
        subTitle: "",
        children: "",
    },
    ui_footer_modal: {
        show: false,
        children: "",
    },
    ui_home_performance_modal: {
        show: false,
        title: "",
        children: "",
    },
    ui_voting_modal: {
        show: false,
        title: "",
        children: "",
    },

    changeRole:false,
    signalRConnaction: null,
    requetedUrl: "/app/home",
};

const ContextStore = ({ children }) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    return (
        <Context.Provider value={[state, dispatch]}>
            {children}
        </Context.Provider>
    );
};

export const Context = createContext(initialState);
export default ContextStore;
